
// Watch
import { Component, Vue } from 'vue-property-decorator';
import { cobrancaStore, companyStore, mainStore, userToolStore } from '@/store';
import _ from 'lodash';

@Component({})
export default class CobrancaList extends Vue {
  public isLoading = false;
  public isLoadingObs = false;
  public searchCompany = '';
  public filterStatusId: null | number = null;
  public filterCompanyC014Id: null | number = null;
  public filterTipoPessoa: null | string = null;

  public detailHeaders = [
    { text: 'Filial', width: 170, value: 'filial', align: 'left', class: 'small' },
    { text: 'Documento', value: 'documento', align: 'center', class: 'small' },
    { text: 'Emissão', value: 'data_emissao', align: 'center', class: 'small' },
    { text: 'Vencimento', value: 'vencimento', align: 'center', class: 'small' },
    {
      text: 'Valor original',
      value: 'valor_original',
      align: 'center',
      class: 'small',
    },
    {
      text: 'Valor atualizado',
      value: 'valor_atualizado',
      align: 'center',
      class: 'small',
    },
    { text: 'Valor pago', value: 'valor_pago', align: 'center', class: 'small' },
    {
      text: 'Observação',
      width: 250,
      value: 'observacao',
      align: 'center',
      class: 'small',
    },
  ];

  public stepOptions = [
    {
      id: 1,
      automatic: false,
      name: 'Notificação',
      prop: '3 dias',
      icon: 'mdi-alert',
      color: 'warning',
    },
    {
      id: 2,
      automatic: false,
      name: 'Notificação',
      prop: '2 dias',
      icon: 'mdi-alert',
      color: 'warning',
    },
    {
      id: 3,
      automatic: false,
      name: 'Notificação',
      prop: '1 dia',
      icon: 'mdi-alert',
      color: 'warning',
    },
    {
      id: 4,
      automatic: false,
      name: 'Notificação',
      prop: 'hoje',
      icon: 'mdi-alert',
      color: 'warning',
    },
    {
      id: 5,
      automatic: false,
      name: 'Contato bloqueio',
      icon: 'mdi-phone',
      color: 'primary',
    },
    {
      id: 6,
      automatic: false,
      name: 'Sem acordo',
      icon: 'mdi-close-circle',
      color: 'blue',
    },
  ];

  get companies() {
    return companyStore.companies;
  }
  get titulos() {
    let titulos: any[] = cobrancaStore.titulos;
    if (!!this.filterStatusId) {
      titulos = _.filter(titulos, { etapa_atual_id: this.filterStatusId });
    }
    if (!!this.filterCompanyC014Id) {
      titulos = _.filter(titulos, { c014_id: this.filterCompanyC014Id });
    }
    if (!!this.filterTipoPessoa) {
      titulos = _.filter(titulos, { tipo_pessoa: this.filterTipoPessoa });
    }
    return _.map(titulos, (t) => {
      t['num_obs'] = t.observacoes ? t.observacoes.length : 0;
      return t;
    });
  }

  set titulos(val) {
    this.$emit('titulosUpdated', val);
  }

  get cobrancaTool() {
    return (
      _.find(userToolStore.currentUserTools, ['tool_id', 21]) || {
        allow_view: false,
        allow_edit: false,
        allow_delete: false,
        allow_create: false,
      }
    );
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  get allowChipClick() {
    return this.currentUser?.is_superuser;
  }

  public isCurrentStatus(index: number, item: any) {
    return index + 1 === item.etapa_item;
  }

  public getStatusPedido(situacao_financeira: string) {
    switch (true) {
      case situacao_financeira === 'Adimplente':
        return 'Liberado';
      case situacao_financeira === 'Inadimplente':
        return 'Bloqueado';
      default:
        return 'Desconhecido';
    }
  }

  public async saveObservacao(item: any) {
    this.isLoadingObs = true;
    await cobrancaStore.createTituloObs({
      t022_id: item.t022_id,
      company_id: item.company_id,
      c014_id: item.c014_id,
      observacoes: item.observacoes,
    });
    await cobrancaStore.getTitulos();
    this.isLoadingObs = false;
  }

  public addObservacao(t022_id: number, step_id: number) {
    this.isLoadingObs = true;
    this.titulos = _.map(this.titulos, (t) => {
      if (t.t022_id === t022_id) {
        if (!!t['observacoes'] && !!t['observacoes'][step_id]) {
          t['observacoes'][step_id].push({
            observacao: '',
            data_proxima_cobranca: '',
          });
        } else {
          t['observacoes'] = {};
          t['observacoes'][step_id] = [
            {
              observacao: '',
              data_proxima_cobranca: '',
            },
          ];
        }
      }
      return t;
    });
    this.isLoadingObs = false;
  }

  public deleteObservacao(cobranca_id: number) {
    this.$swal({
      title: 'Remover observação',
      icon: 'warning',
      text: 'As informações não poderão ser recuperadas',
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.isLoadingObs = true;
        await cobrancaStore.deleteTituloObs(cobranca_id);
        await cobrancaStore.getTitulos();
        this.isLoadingObs = false;
      }
    });
  }

  public semAcordo(item: any) {
    this.$swal({
      title: 'Confirmar título sem acordo',
      icon: 'warning',
      text: 'Após confirmar, o título não poderá mais ser editado',
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.isLoadingObs = true;
        await cobrancaStore.createTituloObs({
          t022_id: item.t022_id,
          company_id: item.company_id,
          etapa_cobranca: '6',
          c014_id: item.c014_id,
          observacoes: { 6: [{ observacao: 'Sem acordo' }] },
          // Só cria uma row se existir ao menos uma observação
        });
        await cobrancaStore.getTitulos();
        this.isLoadingObs = false;
      }
    });
  }

  public async mounted() {
    this.isLoading = true;

    await cobrancaStore.getTitulos();
    await companyStore.getCompanies({ is_active: true });

    this.isLoading = false;
  }
}
